import type { MaxPopupMenu } from '@maxgraph/core';
import type { Store } from '@/graph-store';
import type { ToastCallbacks } from './ContextMenuService';
import { getEditBlockedMessage } from '@/utils/editBlockedMessages';

export function buildEmptyCanvasMenu(
  menu: MaxPopupMenu,
  position: { x: number; y: number },
  store: Store,
  toast?: ToastCallbacks,
): void {
  const isLocked = store.ui.isProtocolLocked || store.ui.isLifecycleLocked || store.ui.isArchived || store.ui.isArchivalInProgress || store.ui.runsExist || store.ui.canEditContent === false;
  const blockedState = {
    isProtocolLocked: store.ui.isProtocolLocked,
    isLifecycleLocked: store.ui.isLifecycleLocked,
    isArchived: store.ui.isArchived,
    isArchivalInProgress: store.ui.isArchivalInProgress,
    runsExist: store.ui.runsExist,
    canEditContent: store.ui.canEditContent,
  };

  menu.addItem('Add Material', 'icon/flask.svg', () => {
    if (isLocked) {
      toast?.showWarning(getEditBlockedMessage(blockedState));
      return;
    }
    store.openModal({
      kind: 'add-material',
      payload: { position },
    });
  });
}
